import { render, staticRenderFns } from "./nepaTermsOfService.vue?vue&type=template&id=af1d9616&scoped=true"
import script from "./nepaTermsOfService.vue?vue&type=script&lang=js"
export * from "./nepaTermsOfService.vue?vue&type=script&lang=js"
import style0 from "./nepaTermsOfService.vue?vue&type=style&index=0&id=af1d9616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1d9616",
  null
  
)

export default component.exports